import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';

/**
 * {
 * worksapces: [{
 *  id: string,
 *  name: string,
 * }],
 * currentWorkspace: string,
 * }
 */

const WORKSPACE_CURRENT_STORAGE = 'appblocks_current_workspace';

export const workspacesSlice = createSlice({
    name: 'workspaces',
    initialState: {
        workspaces: [],
        loaded: false,
        currentWorkspace: localStorage.getItem(WORKSPACE_CURRENT_STORAGE) || '',
    },
    reducers: {
        getWorkspaces: (state, action) => {

        },
        setWorkspaces: (state, action) => {
            state.workspaces = action.payload;
            state.loaded = true;
        },
        setCurrentWorkspace: (state, action) => {
            state.currentWorkspace = action.payload;
            localStorage.setItem(WORKSPACE_CURRENT_STORAGE, action.payload);
        },
        setWorkspaceLoaded: (state, action) => {
            state.loaded = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    getWorkspaces,
    setWorkspaces,
    setCurrentWorkspace,
    setWorkspaceLoaded,
} = workspacesSlice.actions;

export default workspacesSlice.reducer;
